/** Лига и друзья — подключение к стору и колбэкам. */
import type { WindowProps } from "../kit";
import { type FriendsResponse, type LeagueResponse } from "@newfungame/contracts";
import { LeagueView } from "./view";
import { appStore, serverNow, useStore, registerWindow } from "../../../app";
import { actions } from "../actions";
import { playSound } from "../../../audio";
import { seasonDaysLeft } from "@newfungame/engine";
import { useEffect, useState } from "preact/hooks";

export function League({ route, close }: WindowProps<"league">) {
  const league = useStore(appStore, (s) => s.player?.league ?? null);
  const hasPlayer = useStore(appStore, (s) => s.player !== null);
  const [tab, setTab] = useState(route.tab ?? "group");
  const [group, setGroup] = useState<LeagueResponse | null>(null);
  const [friends, setFriends] = useState<FriendsResponse | null>(null);
  const live = league !== null;
  const unclaimed = league?.unclaimed ?? 0;
  useEffect(() => {
    if (!live) return;
    void actions().league().then(setGroup);
    void actions().friends().then(setFriends);
  }, [live, unclaimed]);
  if (!hasPlayer) return null;
  return (
    <LeagueView
      tab={tab}
      guest={!live}
      tier={league?.tier ?? 0}
      unclaimed={unclaimed}
      group={group}
      friends={friends}
      daysLeft={group ? seasonDaysLeft(group.endsAt, serverNow(appStore.get())) : null}
      onTab={setTab}
      onClaim={() => {
        playSound("purchase");
        void actions().claimLeague();
      }}
      onInvite={(url) => actions().inviteFriend(url)}
      onTelegram={() => actions().openTelegram("season")}
      onClose={close}
    />
  );
}

export function register(): void {
  registerWindow("league", League);
}
